// `Reflect.ownKeys` method
// https://tc39.github.io/ecma262/#sec-reflect.ownkeys
require('../internals/export')({ target: 'Reflect', stat: true }, { ownKeys: require('../internals/own-keys') });



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/modules/es.reflect.own-keys.js
// module id = 217
// module chunks = 0